import { Stack } from "@mui/material";
import { InitialNameAvatar } from "../../../components/images/initial-name-avatar";
import { SimpleTable } from "../../../components/mui/table";
import { ENUM_CURRENCY, RENDERER_TYPES } from "../../../enums";
import { convertToFullName, numberFormat } from "../../../services/utils";
import { AmbassadorListExpandedRowData } from "./expanded-row-data";
import { MenuActionButton, UnarchiveActionButton } from "../../../components/buttons";

function AmbassadorListTable({
  list,
  columns,
  handlePageFilters,
  toggleMenuOptions,
  appliedFilters,
  onRowSelect,
  selectedRows,
  showPagination = true,
  isDeleted = false,
  onUnarchiveClick,
}: any) {
  const { selectedPage, selectedPageSize } = showPagination
    ? appliedFilters
    : { selectedPage: 1, selectedPageSize: 1 };

  const handleTDRenderer = (row, column) => {
    switch (column.rendererType) {
      case RENDERER_TYPES.FULL_NAME_WITH_AVATAR:
        return (
          <InitialNameAvatar
            text={convertToFullName(row.firstName, row.lastName)}
            name={row.firstName}
            image
            src={row.photo || row.picture}
          />
        );
      case RENDERER_TYPES.AMOUNT:
        return `${numberFormat(row[column.field], ENUM_CURRENCY.USD)}`;
      case RENDERER_TYPES.NUMBER:
        return `${numberFormat(row[column.field])}`;
      case RENDERER_TYPES.ACTION:
        if (isDeleted) {
          return (
            <Stack gap={1} direction="row" justifyContent="flex-end">
              <UnarchiveActionButton onClick={() => onUnarchiveClick?.(row.id)} />
            </Stack>
          );
        }
        return (
          <MenuActionButton
            onClick={(e) => toggleMenuOptions(e, row.id)}
            key={row.id}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <SimpleTable
        tdRenderer={handleTDRenderer}
        rows={list?.data}
        columns={columns}
        total={list?.total}
        fetching={list?.loading}
        onPageSettingsChange={handlePageFilters}
        selectedPage={selectedPage}
        selectedPageSize={selectedPageSize}
        renderExpandedRowData={({ row }) => (
          <AmbassadorListExpandedRowData data={row} />
        )}
        exandableRow
        onRowSelect={onRowSelect}
        selectedRows={selectedRows}
        showPagination={showPagination}
      />
    </>
  );
}

export { AmbassadorListTable };
